import { Ticket } from "../../../../models/Ticket";
import ResignButton from "../../../shared/Buttons/ResignButton";

// Komponent renderujący przyciski akcji
const ReservationActions: React.FC<{
  cancelReservation: boolean;
  setCancelReservation: (value: boolean) => void;
  onResign: () => void;
  exerciseStartTime: number;
  now: number;
  t: (key: string) => string;
  isDesktop: boolean;
  ticket: Ticket;
}> = ({ cancelReservation, setCancelReservation, onResign, exerciseStartTime, now, t, isDesktop, ticket }) => {
  return (
    <ResignButton
      cancelReservation={cancelReservation}
      setCancelReservation={setCancelReservation}
      onResign={onResign}
      exerciseStartTime={exerciseStartTime}
      now={now}
      isDesktop={isDesktop}
      ticket={ticket}
    />
  );
};

export default ReservationActions;
